// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2e21e140","498":"e1e6a24b","703":"8f6f9f3b"}[chunkId] + ".chunk.js";
};